import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-logo">
        <Link to="/">
          <img src="/images/footerlogo.svg" alt="Cachoeira" width={200} />
        </Link>
      </div>
      <div className="footer-content">
        <div className="footerlinks">
          <div className="first-column">
            <Link to="/">HOME</Link>
            <Link to="/about">ABOUT US</Link>
            <Link to="/services">SERVICES</Link>
          </div>
          <div className="second-column">
            <Link to="/conscious-business">CONSCIOUS BUSINESS</Link>
            <Link to="/our-impact">OUR WORK</Link>
            <Link to="/contact">SAY HI</Link>
          </div>
        </div>
        <div className="social-footer">
          <div className="icons-footer">
            <a href="https://www.instagram.com/wearecachoeira/">
              <img src="/images/insta.svg" alt="instagram" width={50} />
            </a>
            <a href="mailto:suzanne@cachoeira.me">
              <img src="/images/mail.svg" alt="Mail" width={50} />
            </a>
          </div>
          <div className="copyright">&copy; ALL RIGHTS RESERVED.</div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
